import { json } from "@remix-run/node";
import { Link, useLoaderData } from "@remix-run/react";
import Container from "~/components/container";
import { Image } from "~/components/image";
import { Newsletter } from "~/components/newsletter";
import { CACHE_CONTROL } from "~/models/http.server";
import { getBlogPostListings } from "~/models/posts.server";
export const loader = async () => {
  return json(
    { posts: await getBlogPostListings() },
    { headers: { "Cache-Control": CACHE_CONTROL.DEFAULT } }
  );
};

export const meta = () => {
  return [
    {
      title:
        "Marketplace Sellers Blog - Ecommerce News, Takealot, Amazon Tips and More - Shopdeploy",
    },
    {
      name: "description",
      content:
        "A blog about selling on ecommerce marketplaces, running an online business on Takealot, Amazon and updates to Shopdeploy's ecommerce community.",
    },
  ];
};

function BlogPost({ post }) {
  return (
    <div className="w-full rounded overflow-hidden shadow-lg group">
      <Link to={post.slug} aria-label={`Read more about ${post.title}`}>
        <Image
          src={post.imageUrl}
          alt={post.alt}
          width={1200}
          height={600}
          className="w-full group-hover:opacity-75 "
          fit="cover"
        />
      </Link>

      <div className="px-6 py-5">
        <Link to={post.slug} aria-label={`Read more about ${post.title}`}>
          <div className="mb-2 text-sm text-gray-600 font-normal">
            {post.readingTime.text}
          </div>
          <div className="font-bold text-xl mb-2 group-hover:text-blue-900">
            {post.title}
          </div>
          <p className="group-hover:text-blue-900 text-gray-700 text-base">
            {post.summary}
          </p>
        </Link>
      </div>
    </div>
  );
}

export default function BlogIndex() {
  const data = useLoaderData();
  const posts = data.posts;

  // let featuredPosts = data.posts.filter((post) => post.featured);

  return (
    <>
      <div className="bg-green-200/50 px-6 py-4 sm:py-14 lg:px-8">
        <div className="mx-auto max-w-2xl text-left sm:text-center">
          <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-6xl">
            Articles
          </h1>
          <p className="mt-2 text-md leading-7 text-gray-600">
            Learn the vital tasks you need to start your business and set
            yourself up for success.
          </p>
        </div>
      </div>
      <Container>
        {/* Featured Post */}
        {/* <div className="mb-8">
          <BlogPost post={featuredPosts[0]} />
        </div> */}

        {/* Blog Posts Grid */}
        <div className="grid lg:grid-cols-3 gap-6 sm:grid-cols-2 gap-y-10">
          {posts.map((post) => (
            <BlogPost key={post.slug} post={post} />
          ))}
        </div>
        <Newsletter />
      </Container>
    </>
  );
}
